<!-- Start::app-sidebar -->
<aside class="app-sidebar sticky" id="sidebar" [ngClass]="{ 'sticky-pin': scrolled }">
  <!-- Start::main-sidebar-header -->
  <div class="main-sidebar-header">
    <a routerLink="/dashboard" class="header-logo pe-5">
      <img src="./assets/images/companyImages/logo.svg" alt="logo" class="desktop-logo" />
      <img src="./assets/images/companyImages/logo.svg" alt="logo" class="toggle-logo" />
      <img src="./assets/images/companyImages/logo.svg" alt="logo" class="desktop-white" />
      <img src="./assets/images/companyImages/logo.svg" alt="logo" class="toggle-white" />
    </a>
  </div>
  <!-- End::main-sidebar-header -->

  <!-- Start::main-sidebar -->

  <ngx-simplebar [options]="options" class="main-sidebar" id="sidebar-scroll">
    <!-- Start::nav -->
    <nav class="main-menu-container nav nav-pills flex-column sub-open">
      <div class="slide-left" id="slide-left">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
          <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
        </svg>
      </div>
      <ul class="main-menu mt-3">
        <ng-container *ngFor="let menuItem of menuItems">
          <li class="slide has-sub mb-1" [ngClass]="{ open: menuItem.active, active: menuItem.active }">
            <ng-container *ngIf="menuItem.headTitle">
              <div class="slide__category">{{ menuItem.headTitle }}</div>
            </ng-container>
            <!-- link -->

            <a href="javascript:;" class="side-menu__item" [routerLink]="!menuItem.type ? null : [menuItem.path]"
              routerLinkActive="active" *ngIf="menuItem.type === 'link'" (click)="setNavActive(menuItem)">
              <div [ngClass]="{active: menuItem.open}">

                <ng-container *ngIf="menuItem.icon">
                  <span class="iconclick " [innerHTML]="getSanitizedSVG(menuItem.icon)"></span>
                </ng-container>
              </div>
              <span class="side-menu__label">{{menuItem.title}}</span>
              <span class="badge bg-{{ menuItem.badgeClass }} ms-auto menu-badge">{{ menuItem.badgeValue }}</span>
            </a>

            <!-- sub -->
            <a href="javascript:;" class="side-menu__item" *ngIf="menuItem.type === 'sub'"
              (click)="toggleNavActive(menuItem)" [ngClass]="{ active: menuItem.active, open: menuItem.active }">
              <ng-container *ngIf="menuItem.icon">
                <span class="iconclick" [innerHTML]="getSanitizedSVG(menuItem.icon)"></span>
              </ng-container>
              <span class="side-menu__label">{{ menuItem.title }}</span>
              <i class="fe fe-chevron-right side-menu__angle"></i>
            </a>
            <!-- has-mega-menu -->
            <a href="javascript:;" class="side-menu__item" [routerLink]="menuItem.type ? null : menuItem.path"
              *ngIf="menuItem.type === 'mega-menu'" (click)="toggleNavActive(menuItem)"
              [ngClass]="{ active: menuItem.active }">
              <span class="shape1"></span>
              <span class="shape2"></span>
              <span class="side-menu__icon">
                <i class="fe fe-{{ menuItem.icon }} "></i></span>
              <span class="side-menu__label">{{ menuItem.title }}</span>
              <span class="{{ menuItem.badgeClass }}" *ngIf="menuItem.badgeClass && menuItem.badgeValue">
                {{ menuItem.badgeValue }}
              </span>
              <i class="angle fe fe-chevron-right" [ngClass]="{ 'd-none': menuItem.badgeClass }"></i>
            </a>
            <!-- 2nd level menu -->
            <ul class="slide-menu child1" *ngIf="menuItem.children; active"
              [ngStyle]="{ display: menuItem.active ? 'block' : 'none' }">
              <li class="slide has-sub" *ngFor="let childrenItem of menuItem.children" [ngClass]="{
                    open: childrenItem.active,
                    active: childrenItem.active
                  }">
                <!-- Sub -->
                <a href="javascript:;" class="side-menu__item" [ngClass]="{ active: childrenItem.active }"
                  *ngIf="childrenItem.type === 'sub'" (click)="toggleNavActive(childrenItem)">
                  <span class="sub-side-menu__label1">{{
                    childrenItem.title
                    }}</span>
                  <i class="side-menu__angle fe fe-chevron-{{
                        childrenItem.active ? 'right' : 'right'
                      }}" *ngIf="menuItem.children"></i>
                </a>
                <!-- Link -->
                <a href="javascript:;" [routerLink]="!childrenItem.type ? null : childrenItem.path"
                  class="side-menu__item" *ngIf="childrenItem.type === 'link'" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }">
                  <span>{{ childrenItem.title }}</span>
                </a>
                <ul class="slide-menu child2" *ngIf="childrenItem.children" [ngClass]="{ active: childrenItem.active }"
                  [ngStyle]="{
                      display: childrenItem.active ? 'block' : 'none'
                    }">
                  <li class="slide has-sub" *ngFor="let childrenSubItem of childrenItem.children"
                    [ngClass]="{ active: childrenSubItem.active }">
                    <!-- link -->
                    <a href="javascript:;" class="side-menu__item" [routerLink]="
                          !childrenSubItem.type ? null : childrenSubItem.path
                        " *ngIf="childrenSubItem.type === 'link'" routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }">
                      <span>{{ childrenSubItem.title }}</span>
                    </a>
                  </li>
                </ul>
              </li>
              <!-- 2nd Level mega-menu -->

              <ul class="slide-menu mega-menu child1" *ngIf="menuItem.children && menuItem.type === 'mega-menu'"
                [ngClass]="{ open: menuItem.active }">
                <div class="mega-menu">
                  <div *ngFor="let childrenItem of menuItem.children">
                    <ul>
                      <li *ngFor="let Items of childrenItem.items">
                        <a href="javascript:;" routerLinkActive="active" [routerLink]="!Items.type ? null : Items.path"
                          *ngIf="Items.type === 'link'" class="slide-item">
                          {{ Items.title }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </ul>
            </ul>
          </li>
        </ng-container>
      </ul>
      <div class="slide-right" id="slide-right">
        <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
          <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
        </svg>
      </div>
    </nav>
    <!-- End::nav -->
  </ngx-simplebar>


  <!-- End::main-sidebar -->
</aside>
<!-- End::app-sidebar -->